import { apiCweb } from './api-cweb';
import { DbCommit } from '~src/types/db';
import { appLog } from '~src/utils/log';
import { DB_STATE } from '~src/types/enums';

interface LoadCommitParams {
  projectId: string;
  state?: DB_STATE;
}
export const loadCommits = async (
  key,
  { projectId, state }: LoadCommitParams
) => {
  appLog('loadCommits ->', { projectId });
  const res = await apiCweb.get<DbCommit[]>(`/projects/${projectId}/commits`, {
    params: { state },
  });

  // TODO: remove once implemented in backend
  if (state) {
    return res.data.filter((v) => v.state === state);
  }
  return res.data;
};

interface CreateCommitParams {
  projectId: string;
  commitData: Pick<DbCommit, 'description' | 'is_important' | 'state'> &
    Partial<DbCommit>;
}
export const createCommit = async ({
  projectId,
  commitData,
}: CreateCommitParams) => {
  appLog('createCommit ->', { projectId, commitData });

  const res = await apiCweb.post<DbCommit>(
    `/projects/${projectId}/commits`,
    commitData
  );

  return res.data;
};

interface UpdateCommitParams {
  projectId: string;
  commitData: DbCommit;
}
export const updateCommit = async ({
  projectId,
  commitData,
}: UpdateCommitParams) => {
  appLog('updateCommit ->', { projectId, commitData });

  const res = await apiCweb.put<DbCommit>(
    `/projects/${projectId}/commits/${commitData.id}`,
    commitData
  );

  return res.data;
};

interface DeleteCommitParams {
  projectId: string;
  commit: DbCommit;
}
export const deleteCommit = async ({
  projectId,
  commit,
}: DeleteCommitParams) => {
  appLog('deleteCommit ->', { projectId, commit });

  const res = await apiCweb.put(`/projects/${projectId}/commits/${commit.id}`, {
    ...commit,
    state: DB_STATE.REMOVED,
  });

  return res.data;
};
